import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { SERVER_BASE } from '../config/server';
import apiClient from '../utils/apiClient';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

const InventoryModal = ({
  isOpen,
  onRequestClose,
  data,
  refNo,
  prefix,
  fetchTotalQuantityForItem,
  rowData,
  type,
  isClone,
  onSave   // <-- add this
}) => {

  const [rows, setRows] = useState([]);
  const [userQuantities, setUserQuantities] = useState({});
  const [loading, setLoading] = useState(false);
  
  const centerCode = localStorage.getItem('code');
  const token = localStorage.getItem('token');

const fetchLocations = async (quantities = {}) => {
  try {
    const response = await apiClient.get(SERVER_BASE + "/locations", {
      params: { itemId: data?.itemId, item: data?.itemName, centerCode },
      headers: { Authorization: `Bearer ${token}` },
    });
    const options = response.data
      .filter((loc) => loc.availableQuantity > 0)
      .map((loc) => ({
        department: loc.department,
        location: loc.location,
        quantity: loc.availableQuantity,
        uom: loc.uom,
        state:loc.state,
        userQuantity: quantities[loc.location] || 0, // ✅ merge with live quantities
      }));

    setRows(options);
  } catch (error) {
    console.error("Error fetching locations:", error);
  }
};

useEffect(() => {
  if (!isOpen || !data?.itemId) return;

  let qtyMap = {};

  // Prefill only if itemId matches & location matches
  if (Array.isArray(data.locationDetails) && data.locationDetails.length > 0) {
    data.locationDetails.forEach((loc) => {
      // Only take quantities belonging to SAME ITEMID
      if (loc.itemId == data.itemId) {
        qtyMap[loc.location] = Number(loc.userQuantity) || 0;
      }
    });
  }

  // Always load DB rows but inject prefilled userQuantity
  fetchLocations(qtyMap);

}, [isOpen, data]);

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };
  
  // const handleSaveAndClose = async () => {
  //   // Validate quantity
  //   const invalidRow = rows.find(
  //     (row) => parseFloat(row.userQuantity) > row.quantity
  //   );
  
  //   if (invalidRow) {
  //     Swal.fire({
  //       toast: true,
  //       icon: "error",
  //       showConfirmButton: false,
  //       timer: 2000,
  //       position: "top-end",
  //       timerProgressBar: true,
  //       text: `The Challan quantity for location "${invalidRow.location}" cannot exceed the available quantity.`,
  //     });
  //     return;
  //   }
  
  //   const locationDetails = rows
  // .filter(
  //   (row) =>
  //     row.userQuantity != null &&
  //     row.userQuantity != "" &&
  //     !isNaN(row.userQuantity) &&
  //     Number(row.userQuantity) > 0
  // )
  // .map((row) => ({
  //   itemId: data?.itemId,
  //   department: row.department,
  //   location: row.location,
  //   quantity: row.quantity,
  //   userQuantity: Number(row.userQuantity),
  //   remaining: row.quantity - Number(row.userQuantity),
  //   uom: row.uom,
  //   state: row.state,
  // }));


    
  //   // Call parent callback instead of saving to DB
  //   if (typeof onSave == "function") {
  //     onSave(locationDetails);
  //   }
  
  //   onRequestClose(); // close modal
  // };
  
  
  

  // Calculate totals for the table footer
  
  
  
  const handleSaveAndClose = async () => {

    // ✅ Validation: qty must be > 0 (if user entered something)
    const invalidQtyRow = rows.find((row) => {
      const val = row.userQuantity;
  
      // ignore empty/null
      if (val == "" || val == null || val == undefined) return false;
  
      // invalid number OR <= 0
      return isNaN(val) || Number(val) <= 0;
    });
  
    if (invalidQtyRow) {
      Swal.fire({
        toast: true,
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
        position: "top-end",
        timerProgressBar: true,
        text: `Challan quantity for location "${invalidQtyRow.location}" must be greater than 0.`,
      });
      return;
    }
  
    // ✅ Existing validation: qty cannot exceed available
    const invalidRow = rows.find(
      (row) => parseFloat(row.userQuantity) > row.quantity
    );
  
    if (invalidRow) {
      Swal.fire({
        toast: true,
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
        position: "top-end",
        timerProgressBar: true,
        text: `The Challan quantity for location "${invalidRow.location}" cannot exceed the available quantity.`,
      });
      return;
    }
  
    const locationDetails = rows
      .filter(
        (row) =>
          row.userQuantity != null &&
          row.userQuantity !== "" &&
          !isNaN(row.userQuantity) &&
          Number(row.userQuantity) > 0
      )
      .map((row) => ({
        itemId: data?.itemId,
        department: row.department,
        location: row.location,
        quantity: row.quantity,
        userQuantity: Number(row.userQuantity),
        remaining: row.quantity - Number(row.userQuantity),
        uom: row.uom,
        state: row.state,
      }));
  
    if (typeof onSave === "function") {
      onSave(locationDetails);
    }
  
    onRequestClose();
  };
  
  const totalAvailable = rows.reduce((acc, row) => acc + (row.quantity || 0), 0);
  const totalChallan = rows.reduce((acc, row) => acc + (parseFloat(row.userQuantity) || 0), 0);

  const totalRemaining = totalAvailable - totalChallan;

  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Edit Location"
      style={{
        content: {
          height: "80%",
          width: "65%",
          margin: "auto",
        },
      }}
    >
      <div className="modal-content">
        <div className="modal-header d-flex justify-content-between">
          <h5 className="modal-title">Edit Item Details</h5>
          <h6 className="modal-title">Click on refresh to load quantity</h6>
          <button
            type="button"
            className="btn btn-success"
            onClick={handleSaveAndClose}
          >Save & Close</button>
        </div>
        <div className="modal-body">
          <div className="row mb-3">
            <div className="col-md-4">
              <label className="form-label">Item Name</label>
              <input
                type="text"
                className="form-control"
                value={data?.itemName || ""}
                disabled
              />
            </div>
          </div>

          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Department</th>
                <th>Location</th>
                <th>State</th>
                <th>Available</th>
                <th>Challan</th>
                <th>Remaining</th>
                <th>UOM</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  <td>{row.department}</td>
                  <td>{row.location}</td>
                  <td>{row.state}</td>
                  <td>{row.quantity}</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      value={row.userQuantity || ""}
                      onChange={(e) =>
                        handleRowChange(index, "userQuantity", e.target.value)
                      }
                      placeholder="Enter Quantity"
                    />
                  </td>
                  <td>{(row.quantity - (parseFloat(row.userQuantity) || 0))?.toFixed(2)}</td>
                  <td>{row.uom}</td>
                  
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td><strong>Total</strong></td>
                <td></td>
                <td></td>
                <td><strong>{totalAvailable}</strong></td>
                <td><strong>{totalChallan}</strong></td>
                <td><strong>{totalRemaining?.toFixed(2)}</strong></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      {/* <footer>
          <div className="text-end"><button type="button" className="btn btn-primary" onClick={onRequestClose}>Close</button></div>
          </footer> */}
    </Modal>
  );
};

export default InventoryModal;
